import React from "react";

import SupportBoardContent from "@sellernote/shipda-kr/src/containers/SupportBoardContent";

import { getServerSidePropsForSupport } from "../../utils";

export default function UseContent() {
  return <SupportBoardContent />;
}

export const getServerSideProps =
  getServerSidePropsForSupport("/support/guide/use");
